import React from 'react';
import { HeaderGroup } from 'react-table';
import classNames from 'classnames';

import { SortIcon } from './sort-icon.component';
import { getAriaSortString } from './table.util';

type TableHeaderProps = {
  headerGroups: HeaderGroup<object>[];
};

export const TableHeader = ({ headerGroups }: TableHeaderProps) => (
  <>
    {headerGroups.map((headerGroup) => (
      <tr {...headerGroup.getHeaderGroupProps()}>
        {headerGroup.headers.map((column) => (
          <th
            {...column.getHeaderProps(column.getSortByToggleProps())}
            className={classNames(
              'py-2 font-medium text-left text-gray-400 text-sm whitespace-nowrap border-b border-gray-100',
              column.id === 'selection' ? 'px-2 w-0' : 'px-6'
            )}
            title={undefined}
            aria-sort={getAriaSortString(column)}
          >
            <div className="flex items-center">
              {column.render('Header')}
              {column.canSort && (
                <SortIcon
                  isSorted={column.isSorted}
                  isDesc={column.isSortedDesc}
                />
              )}
            </div>
          </th>
        ))}
      </tr>
    ))}
  </>
);
